import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";
import FinanceiroEntregadores from "../../pages/FinanceiroEntregadores";
import Entregadores from "../../pages/Entregadores";
import MapaEstabelecimentos from "../../pages/Mapa";

export default class ControlledTabs extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      key: "FinanceiroEntregadores",
    };
  }

  render() {
    return (
      <div>
        <Tabs
          style={{ paddingTop: 7, marginTop: -1 }}
          id="controlled-tab-example"
          className="tabStyle"
          activeKey={this.state.key}
          onSelect={(key) => this.setState({ key })}
        >
          <Tab
            style={{ paddingLeft: 20 }}
            eventKey="FinanceiroEntregadores"
            title="Finanças"
          >
            <FinanceiroEntregadores></FinanceiroEntregadores>
          </Tab>
          <Tab eventKey="Entregadores" title="Entregadores Cadastrados">
            <Entregadores></Entregadores>
          </Tab>
          <Tab
            eventKey="MapaEstabelecimentos"
            title="Mapa de Entregadores e Estabelecimentos"
          >
            <MapaEstabelecimentos></MapaEstabelecimentos>
          </Tab>
        </Tabs>
      </div>
    );
  }
}
